var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#7269EF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6607 16.0561C16.9857 16.0561 17.25 16.3238 17.25 16.653C17.25 16.9829 16.9857 17.25 16.6607 17.25H13.3298C13.0048 17.25 12.7405 16.9829 12.7405 16.653C12.7405 16.3238 13.0048 16.0561 13.3298 16.0561H16.6607ZM14.3507 7.15779L15.2112 7.84129C15.564 8.1172 15.7992 8.4809 15.8797 8.86341C15.9726 9.28417 15.8735 9.69741 15.595 10.0548L10.4696 16.6829C10.2343 16.9839 9.8877 17.1532 9.51629 17.1595L7.47356 17.1846C7.36214 17.1846 7.26929 17.1093 7.24453 17.0027L6.78027 14.9899C6.6998 14.6199 6.78027 14.2374 7.0155 13.9427L10.6491 9.23965C10.711 9.1644 10.8224 9.15249 10.8967 9.2083L12.4256 10.4248C12.5247 10.5063 12.6609 10.5502 12.8032 10.5314C13.1065 10.4938 13.3108 10.2179 13.2799 9.92315C13.2613 9.77266 13.187 9.64724 13.088 9.55318C13.057 9.5281 11.6024 8.36176 11.6024 8.36176C11.5095 8.28651 11.4909 8.14855 11.5652 8.05512L12.1409 7.30828C12.6732 6.62478 13.6017 6.56207 14.3507 7.15779Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditBtn);
export default __webpack_public_path__ + "static/media/edit-btn.2a1b3f38af8cf66da8731d769898c67e.svg";
export { ForwardRef as ReactComponent };